import type { Middleware, MiddlewareAPI } from "redux";
import type { ActionType, PayloadAction } from "typesafe-actions";
import { isActionOf } from "typesafe-actions";

import SIAllTrackersService from "app/pages/sales-intelligence/services/tracking/SIAllTrackersService";
import userActivityService from "app/pages/sales-intelligence/services/userActivityService";
import {
    deleteSavedSearchAsync,
    saveNewSearchAsync,
} from "app/pages/sales-intelligence/sub-modules/advanced-search/store/action-creators";
import type * as actionCreators from "app/pages/sales-intelligence/sub-modules/common/store/action-creators";
import {
    createProfileAsync,
    deleteProfileAsync,
} from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/store/action-creators";
import {
    createOpportunityListAsync,
    deleteOpportunityListAsync,
} from "app/pages/sales-intelligence/sub-modules/opportunities/store/action-creators";
import {
    createSignalAsync,
    deleteSignalsAsync,
    saveDraftSignalSuccess,
} from "app/pages/sales-intelligence/sub-modules/signals/store/action-creators";
import { allTrackers } from "app/services/track/track";

async function updateTrackingParams(): Promise<void> {
    try {
        const data = await userActivityService.fetch();

        if (allTrackers instanceof SIAllTrackersService) {
            allTrackers.setCustomTrackingParams(data);
        }
    } catch {
        /* Can ignore the error for this request in the middleware */
    }
}

const siAllTrackersMiddleware: Middleware =
    (_store: MiddlewareAPI) =>
    (next: (action: ActionType<typeof actionCreators>) => PayloadAction<any, any>) =>
    (action: ActionType<typeof actionCreators>): PayloadAction<any, any> => {
        switch (true) {
            case isActionOf(saveNewSearchAsync.success, action):
            case isActionOf(deleteSavedSearchAsync.success, action):
            case isActionOf(createOpportunityListAsync.success, action):
            case isActionOf(deleteOpportunityListAsync.success, action):
            case isActionOf(createSignalAsync.success, action):
            case isActionOf(saveDraftSignalSuccess, action):
            case isActionOf(deleteSignalsAsync.success, action):
            case isActionOf(createProfileAsync.success, action):
            case isActionOf(deleteProfileAsync.success, action):
                void updateTrackingParams();
        }

        return next(action);
    };

export default siAllTrackersMiddleware;
